import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import AirComponent from "../../components/Air";
import Sidebar from "../../components/Sidebar";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as airActions from "../../redux/actions/airAction";
import * as stdActions from "../../redux/actions/stdAction";
import * as notificationActions from "../../redux/actions/notificationAction";
import { setLanguage } from "redux-i18n";
import PropTypes from "prop-types";
import { useRef } from "react";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";
import { useLocation } from "react-router-dom";
import * as userAuthActions from "../../redux/actions/userAuthAction";

const Air = (props, context) => {
  const attachmentRef = useRef();
  const stdReducer = useSelector((state) => state.stdReducer);
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const airReducer = useSelector((state) => state.airReducer);
  const i18nReducer = useSelector((state) => state.i18nState);
  const notificationReducer = useSelector((state) => state.notification);


  const dispatch = useDispatch();
  let stdAction = bindActionCreators(stdActions, dispatch);
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);
  const airAction = bindActionCreators(airActions, dispatch);
  const notificationAction = bindActionCreators(notificationActions, dispatch);
  const userAuthAction = bindActionCreators(userAuthActions, dispatch);

  let urllocation = useLocation();

  // Call required apis for dropdown after first render
  useEffect(() => {
    airAction.prepareAirConfigData();
  }, []);

  //set max form step
  const setMaximumFormStep = (maxCount) => {
    airAction.setMaximumFormStep(maxCount);
  };

  //set minumum form step
  const setMinimumFormStep = (minCount) => {
    airAction.setMinimumFormStep(minCount);
  };

  //set current form step
  const setCurrentFormStep = (stepCount) => {
    airAction.setCurrentFormStep(stepCount);
  };

  //upload air file
  const uploadFiles = (file, allFiles, props) => {
    stdAction.uploadFiles(file, allFiles, props);
  };

  //set attachment
  const setAttachment = (attachment) => {
    stdAction.setAttachment(attachment);
  };

   //get all country province
   const getStates = (contryId) => {
    stdAction.getState(contryId);
  }

  //remove air file 
  const removeFiles = (filePath, isDocs, index, allAttachments) => {
    stdAction.removeFiles(filePath, isDocs, index, allAttachments);
  };

  //for open modal 
  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  //for closing modal
  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };


  //add air application 
  const addAirEmployeeStatement = (airData) => {
    airAction.addAirEmployeeStatement(airData, profileReducer.managersDetails.managerId);
  };

  const resetIsAdded = (isAdded) => {
    airAction.resetIsAdded(isAdded);
  };

  //add new manager
  const addNewManager = (managerDetails) => {
    commonAction.addNewManager(managerDetails);
  };

  //reset air application
  const resetAirApplicationUrl = () => {
    airAction.resetAirApplicationUrl();
  };

  //get all pending application
  const getAllPendingApplications = (managerId) => {
    notificationAction.getAllPendingApplications(managerId);
  }

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  const resetSuccessMessage = (message) => {
    commonAction.setSuccessMessage(message);
  }

  //reset air reducer
  const resetAirReducer = () => {
    airActions.resetState();
  }

  const setOnSubmit = (isOnSubmit) => {
    notificationAction.setOnSubmit(isOnSubmit);
  }

  const resetsuccessMessageForBackupUserAssigned = () => userAuthAction.resetsuccessMessageForBackupUserAssigned();

  const resetAirEmployeeStatement = () => airAction.resetAirEmployeeStatement();

  // getting CANADA province only
  useEffect(() => {
    if (stdReducer.country && stdReducer.country.length) {
      let canadaObj = stdReducer.country.find(x => x.countryName == "Canada")
      stdAction.getState(canadaObj.countryId)
    }
  }, [stdReducer.country])

  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div className="Content-Panel">
        <ShowForPermission module={PERMISSON_MODULES.AIR_FORM} permission={PERMISSION_TYPE.VIEW}>
          <AirComponent
            getStates={getStates}
            urlLocation={urllocation}
            stepCount={airReducer.step}
            maxStep={airReducer.maxSteps}
            minStep={airReducer.minSteps}
            setMaxStep={setMaximumFormStep}
            setMinStep={setMinimumFormStep}
            addAirEmployeeStatement={addAirEmployeeStatement}
            setCurrentFormStep={setCurrentFormStep}
            resetIsAdded={resetIsAdded}
            airFormPdfLink={airReducer.airFormPdfLink}
            managersDetails={profileReducer.managersDetails}
            isAdded={airReducer.isAdded}
            i18nReducer={i18nReducer}
            i18nReducerLang={i18nReducer.lang}
            resetAirApplicationUrl={resetAirApplicationUrl}
            context={context}
            supervisorList={stdReducer.supervisorList}
            job={stdReducer.job}
            uploadFiles={uploadFiles}
            removeFiles={removeFiles}
            openSetModalAction={openSetModal}
            closeRemoveModal={closeRemoveModal}
            attachmentRef={attachmentRef}
            attachment={stdReducer.attachment}
            setAttachment={setAttachment}
            location={stdReducer.location}
            addNewManager={addNewManager}
            getAllPendingApplications={getAllPendingApplications}
            allPendingApplications={notificationReducer.allPendingApplications}
            contiuedPendingApplicationObj={airReducer.airEmployeeStatememt}
            resetContiuedPendingApplicationObj={resetAirEmployeeStatement}
            resetAirReducer={resetAirReducer}
            companyName={profileReducer.managerDetails ? profileReducer.managerDetails.companyName : 0}
            notificationReducer={notificationReducer}
            resetSuccessMessage={resetSuccessMessage}
            commonReducer={commonReducer}
            profileReducer={profileReducer}
            state={stdReducer.state}
            country={stdReducer.country}
            resetsuccessMessageForBackupUserAssigned={resetsuccessMessageForBackupUserAssigned}
          />
        </ShowForPermission>
      </div>
    </>
  );
};

Air.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Air;
